import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import contactNoteDialogService from 'services/contactNoteDialogService';
import { TopicDropdownOption } from 'utils/contactNoteUtil';

export const useGetTopicDropdownValues = (fromTopics = false) => {
  return useQuery<TopicDropdownOption[], AxiosError>({
    queryKey: ['topicDropdownValues', { fromTopics }],
    queryFn: () => contactNoteDialogService.getTopicDropdownValues(fromTopics),
  });
};
